// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oCpYn","label":"styles_label__3_fve"};